export default __webpack_public_path__ + "static/media/08_gallery.b0adc1ab.jpg";